import { LocationService } from '../location.service';
import { Injectable } from '@angular/core';
import { LuigiCoreService } from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class GithubInstallationService {
  constructor(
    private locationService: LocationService,
    private luigiCoreService: LuigiCoreService,
  ) {}

  public async executeGithubInstallationFlow(
    domain: string,
    targetId?: string,
    state?: string,
    appName?: string,
  ): Promise<void> {
    if (!appName) {
      throw new Error(
        `GitHub App name is required to start the installation flow for domain: ${domain}`,
      );
    }

    const baseUrl = `https://${domain}/github-apps/${appName}/installations/new`;
    let installationUrl = targetId
      ? `${baseUrl}/permissions?target_id=${targetId}`
      : baseUrl;
    if (state) {
      // Override redirectUrl in the state so it points to this shell, not the MFE.
      // github-ui builds the state but doesn't know jukebox's origin.
      try {
        const stateObj = JSON.parse(decodeURIComponent(state));
        stateObj.redirectUrl = `${window.location.origin}/github-installation`;
        state = encodeURIComponent(JSON.stringify(stateObj));
      } catch {
        // leave state as-is if it can't be parsed
      }
      installationUrl += `${targetId ? '&' : '?'}state=${state}`;
    }

    const result =
      await this.locationService.openInstallationWindow(installationUrl);

    if (!result) {
      void this.luigiCoreService.showAlert({
        text: 'GitHub App installation was not completed. The organization was not added.',
        type: 'error',
      });
      return;
    }

    if (result.state) {
      const stateJson = JSON.parse(decodeURIComponent(result.state)) as {
        ghDomain?: string;
        orgId?: string;
        modal?: { path: string; settings: string };
      };

      if (stateJson.modal?.path) {
        const modalSettings = JSON.parse(stateJson.modal.settings ?? '{}');
        const nodeParams = [
          result.installationId
            ? `~installationId=${result.installationId}`
            : '',
          stateJson.ghDomain ? `~ghDomain=${stateJson.ghDomain}` : '',
          stateJson.orgId ? `~orgId=${stateJson.orgId}` : '',
        ]
          .filter(Boolean)
          .join('&');
        const modalPath = nodeParams
          ? `${stateJson.modal.path}?${nodeParams}`
          : stateJson.modal.path;

        this.luigiCoreService
          .navigation()
          .openAsModal(modalPath, modalSettings);
      }
    }
  }
}
